import React__default from 'react';
import { NvTabsHeader } from '../NvTabsHeader/NvTabsHeader.esm.js';
import '../NvTabsHeader/NvTabsHeader.hooks.esm.js';
import { NvTabsTextContent } from '../NvTabsTextContent/NvTabsTextContent.esm.js';
import styles from './NvTabsContent.module.esm.js';

var NvTabsContent = function (_a) {
    var children = _a.children, alignment = _a.alignment, body = _a.body, heading = _a.heading, subheading = _a.subheading, tabs = _a.tabs;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(NvTabsTextContent, { alignment: alignment, body: body, heading: heading, subheading: subheading }),
        React__default.createElement(NvTabsHeader, { tabs: tabs }),
        React__default.createElement("div", { className: styles.tabsWrapper }, children)));
};

export { NvTabsContent };
//# sourceMappingURL=NvTabsContent.esm.js.map
